/**
 * Sales -> Shipments permission (user, 2026-10-21: "Create new permission
 * sales->shipments for it"). Replaces the old Utility "Ups Tracking"
 * (utility_ups_tracking), which nothing checks any more.
 *
 * One rule for the menu item, the page route and the Customer "Tracking" tab,
 * so they can never disagree. The API checks the same permission on every
 * Shipments route (nova-api middleware/requirePermission.js), against the DB.
 */
export const SHIPMENTS_PERMISSION = "s_shipments";

export const canUseShipments = (user) =>
  user?.roles === "admin" || !!user?.permissions?.includes(SHIPMENTS_PERMISSION);
